import { PermissionNames } from "../types/account.types"
import { RightElement, SettingsParentPage } from "./header.types"

export const NAVIGATION_ITEMS = [
  {
    route: '/pages/how-it-works/main',
    name: 'How it Works'
  },
  {
    route: '/pages/about-us/main',
    name: 'About Us',
    submenu: [
      {
        route: '/pages/about-us/main',
        name: 'Who We Are',
      },
      {
        route: '/pages/producers',
        name: 'Our Producers'
      },
      {
        route: '/pages/contact-us',
        name: 'Contact Us'
      },
    ]
  },
  {
    route: '/pages/faq/prospective-members',
    name: 'FAQ'
  },
  {
    route: '/pages/gift-cards',
    name: 'Gift Cards'
  },
  {
    route: '/pages/blog',
    name: 'Blog'
  }
]

export const SETTINGS_PAGES: SettingsParentPage[] = [
  {
    icon: 'person',
    name: 'Account Settings',
    children: [
      {
        route: '/settings/account/profile',
        name: 'Profile',
        permissionName: PermissionNames.settingsProfile
      },
      {
        route: '/settings/account/subscriptions',
        name: 'Subscriptions',
        permissionName: PermissionNames.settingsSubscription
      },
      {
        route: '/settings/account/deliveries',
        name: 'Deliveries',
        name2: 'Pick-Ups',
        permissionName: PermissionNames.settingsDeliveries
      },
      {
        route: '/settings/account/friend-referrals',
        name: 'Friend Referrals',
        permissionName: PermissionNames.settingsFriednReferrals
      },
    ],
    permissionName: PermissionNames.settings
  },
  {
    icon: 'credit_card',
    name: 'Billing Settings',
    children: [
      {
        route: '/settings/billing/payment-method',
        name: 'Payment Method',
        permissionName: PermissionNames.settingsPaymentMethod
      },
      {
        route: '/settings/billing/membership',
        name: 'Membership',
        permissionName: PermissionNames.settingsMemebership
      },
      {
        route: '/settings/billing/order-and-billing',
        name: 'Order & Billing',
        permissionName: PermissionNames.settingsOrderHistory
      },
      {
        route: '/settings/billing/invoice-history',
        name: 'Invoice History',
        permissionName: PermissionNames.settingsInvoiceHistory
      },
    ],
    permissionName: PermissionNames.settings
  },
]

export const RIGHT_ELEMENTS: RightElement[] = [
  {
    tooltip: 'Favorites',
    route: '/favorites',
    icon: 'favorite',
    permissionName: PermissionNames.shop
  },
  {
    tooltip: 'Buy Again',
    route: '/buy-again',
    icon: 'verified',
    permissionName: PermissionNames.shop
  },
  {
    tooltip: 'Cart',
    route: '/order',
    icon: 'shopping_cart',
    showBadge: true,
    permissionName: PermissionNames.order,
    showWithoutPermission: true
  },
]
